import { createI18n } from 'vue-i18n'

const seenMissingKeys = new Set()

let currentRouteName = null

const localeName = (value) => (typeof value === 'string' ? value : value?.value)

export const resetSeenMissingKeys = (routeName = null) => {
    seenMissingKeys.clear()
    currentRouteName = routeName
}

export const vueI18n = (initialLocale = 'en-GB') => {
    window.messages = {}
    if (window.vuei18nLocales !== undefined) {
        Object.keys(window.vuei18nLocales).forEach(function (lang) {
            window.messages[lang] = window.vuei18nLocales[lang]
        })
    }

    const instance = createI18n({
        locale: initialLocale,
        fallbackLocale: 'en-US',
        messages: window.messages,
        silentTranslationWarn: true,
        missingWarn: false,
        fallbackWarn: false,
        missing: (locale, key) => {
            if (!key || seenMissingKeys.has(key)) return key
            seenMissingKeys.add(key)

            const userLocale = localeName(instance.global.locale) || locale
            const route = currentRouteName

            import('@/stores/missingTranslations')
                .then(({ useMissingTranslationsStore }) => {
                    useMissingTranslationsStore().record({ key, locale: userLocale, route })
                })
                .catch(() => {})

            return key
        },
    })

    return instance
}
